"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment/moment"));
var hours_list_1 = require("../../common/constants/hours_list");
var minutes_list_1 = require("../../common/constants/minutes_list");
var AdminEditDriveSession = /** @class */ (function () {
    function AdminEditDriveSession(DrivesModel, UserService, UsersModel) {
        this.state = {
            driveSession: {
                zones: [],
                zoneparts: [],
                sectors: [],
                zone_id: 0,
                location: {
                    zones: [],
                    zoneparts: []
                },
                student: undefined,
                observation: false,
                students: [],
                notes: null,
                student_id: 0,
                status: 'Available',
                drive_date: '',
                start_time: ''
            },
            form: {
                hoursList: hours_list_1.hours_list,
                minutesList: minutes_list_1.minutes_list,
                sessiontypes: [],
                campuses: [], //school.locations  // can just be vm.campuses and set in init
                selectAllSectorsLabel: '',
                // selectAllSectors // method
                zones: [], // available zones to select
                sectors: [], // the available sectors to select
                instructors: [],
                vehicles: [],
                submitted: false,
                busy: false
            },
            rules: {
                sectorsRequired: true,
                hasStudents: false, // this should be a boolean
                hasSectors: false,
                noteLengthValid: true
            }
        };
        this.DrivesModel = DrivesModel;
        this.UserService = UserService;
        this.UsersModel = UsersModel;
        this.updateSessionDate = this.updateSessionDate.bind(this);
        this.updateSessionTime = this.updateSessionTime.bind(this);
    }
    AdminEditDriveSession.prototype.setDriveSession = function (data) {
        this.state.driveSession = data;
    };
    AdminEditDriveSession.prototype.hasStudents = function () {
        var studentsOnSession = [];
        if (this.state.driveSession.hasOwnProperty('student') && this.state.driveSession.student !== null) {
            studentsOnSession.push(this.state.driveSession.student);
        }
        if (this.state.driveSession.observation === true && !this.state.driveSession.students) {
            this.state.driveSession.students = [];
        }
        if (this.state.driveSession.hasOwnProperty('students') && this.state.driveSession.students.length > 0) {
            this.state.driveSession.students.forEach(function (student) {
                studentsOnSession.push(student);
            });
        }
        if (studentsOnSession.length === 0) {
            return false;
        }
        var result = studentsOnSession.length > 0;
        this.state.rules.hasStudents = result;
        return result;
    };
    AdminEditDriveSession.prototype.noteLengthValid = function () {
        if (!this.state.driveSession.notes) {
            return true;
        }
        return this.state.driveSession.notes.length <= 500;
    };
    /**
     * Whether or not this session can be deleted. Defaults to true, may change in the future.
     */
    AdminEditDriveSession.prototype.driveSessionCanBeDeleted = function () {
        var hasStudents = false;
        if (this.state.driveSession.student_id !== null) {
            hasStudents = true;
        }
        if (this.state.driveSession.hasOwnProperty('students') && this.state.driveSession.students.length > 0) {
            hasStudents = true;
        }
        return ((0, moment_1.default)((0, moment_1.default)(this.state.driveSession.drive_date).format('YYYY-MM-DD') + ' ' +
            (0, moment_1.default)(this.state.driveSession.start_time).format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss').isBefore((0, moment_1.default)()) || this.state.driveSession.status === 'Available') && hasStudents === false; // this.state.driveSession.status == 'Available' || this.state.driveSession.status == 'Complete'
    };
    AdminEditDriveSession.prototype.resetForm = function () {
        this.state.form.sectors = [];
        this.state.form.zones = [];
    };
    AdminEditDriveSession.prototype.resetDriveSession = function () {
        // Clear zones and sectors
        this.state.driveSession.zone_id = null;
        this.state.driveSession.sectors = [];
        this.state.driveSession.zoneparts = [];
    };
    AdminEditDriveSession.prototype.checkSelectedSectors = function () {
        if (this.state.rules.sectorsRequired === false) {
            this.state.rules.hasSectors = true;
            return true;
        }
        this.state.rules.hasSectors = false;
        var hasSectors = [].concat(this.state.form.sectors).filter(function (sector) { return sector.selected; }).length > 0;
        this.state.rules.hasSectors = hasSectors;
        return this.state.rules.hasSectors;
    };
    AdminEditDriveSession.prototype.updateSelectAllZonesLabel = function () {
        var label = '';
        var zones = [].concat.apply([], this.state.form.zones).filter(function (zone) { return zone.selected; });
        if (zones.length === 1) {
            label = 'Select all Sectors in Zone ';
        }
        else {
            label = 'Select all Sectors in Zones ';
        }
        zones.forEach(function (zone) {
            label += ' ' + zone.name + ', ';
        });
        label.trim().replace(/,+$/, '').replace(/,\s*$/, '');
        label = label.slice(0, -2);
        this.state.form.selectAllSectorsLabel = label;
    };
    AdminEditDriveSession.prototype.updateSessionDate = function (newDate) {
        //used with vue flatpickr
        this.state.driveSession.drive_date = newDate.selected[0];
    };
    AdminEditDriveSession.prototype.updateSessionTime = function (newTime) {
        //used with vue flatpickr
        this.state.driveSession.start_time = newTime.selected[0];
    };
    return AdminEditDriveSession;
}());
AdminEditDriveSession.$inject = ['DrivesModel', 'UserService', 'UsersModel'];
exports.default = AdminEditDriveSession;
